var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_78_55734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00391 9.68546L9.60622 8.18671L7.00391 6.68796V9.68546Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 0.187958C3.58241 0.187958 0 3.77036 0 8.18796C0 12.6056 3.58241 16.188 8 16.188C12.4176 16.188 16 12.6056 16 8.18796C16 3.77036 12.4176 0.187958 8 0.187958ZM12.9987 8.19615C12.9987 8.19615 12.9987 9.81858 12.793 10.6009C12.6776 11.0291 12.34 11.3668 11.9117 11.482C11.1294 11.688 8 11.688 8 11.688C8 11.688 4.87878 11.688 4.08825 11.4738C3.66003 11.3586 3.32238 11.0208 3.20703 10.5926C3.00109 9.81855 3.00109 8.18796 3.00109 8.18796C3.00109 8.18796 3.00109 6.56565 3.20703 5.78327C3.32228 5.35508 3.66822 5.00911 4.08828 4.8939C4.87056 4.68796 8 4.68796 8 4.68796C8 4.68796 11.1294 4.68796 11.9117 4.90208C12.34 5.0173 12.6776 5.35508 12.793 5.7833C13.0071 6.56565 12.9988 8.19611 12.9988 8.19611L12.9987 8.19615Z",
    fill: "#868686"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_78_55734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.187958)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.113e8b6dec9beb34e08b9db8fe3462f7.svg";
export { ForwardRef as ReactComponent };